import {
  PvPolicyDuration,
  PvPolicyFormModel,
  PvPolicyLabelMatchExpression,
  PvPolicyLabelOperator,
  PvPolicyTarget,
} from './_types';
import { PvPolicyPageTabId, PvPolicySettingsTabId } from './_tabs/types';

export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const SECONDS_PER_HOUR = SECONDS_PER_MINUTE * MINUTES_PER_HOUR;

export const PERIOD_PATTERN = /^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/;

export const ZERO_DURATION: PvPolicyDuration = {
  hours: 0,
  minutes: 0,
  isCustom: true,
};

export const KNOWN_LABEL_OPERATORS: ReadonlyArray<PvPolicyLabelOperator> = [
  'In',
  'NotIn',
  'Exists',
  'DoesNotExist',
];

export const KNOWN_PERFORMANCE_TARGETS: ReadonlyArray<PvPolicyTarget> = [
  'max',
  'p95',
  'p99',
  'p80',
];

export const PV_POLICY_DUPLICATE_FROM_NAME_URL_KEY = 'duplicateFromName';
export const PV_POLICY_PAGE_TAB_URL_KEY = 'tab';
export const PV_POLICY_SETTINGS_TAB_URL_KEY = 'setting';

export const PV_POLICY_PAGE_TAB_IDS: ReadonlyArray<PvPolicyPageTabId> = [
  'settings',
  'targetingRules',
];

export const DEFAULT_PV_POLICY_PAGE_TAB: PvPolicyPageTabId = 'settings';

export const DEFAULT_PV_POLICY_SETTINGS_TAB: PvPolicySettingsTabId =
  'optimizationDimensions';

export const PVC_LABEL_OPERATORS: ReadonlyArray<{
  value: PvPolicyLabelOperator;
  label: string;
}> = [
  { value: 'In', label: 'In' },
  { value: 'NotIn', label: 'Not in' },
  { value: 'Exists', label: 'Exists' },
  { value: 'DoesNotExist', label: "Doesn't exist" },
];

export const EMPTY_PV_POLICY_LABEL_MATCH_EXPRESSION: PvPolicyLabelMatchExpression =
  {
    key: '',
    operator: 'In',
    values: [],
  };

export const NEW_POLICY_INITIAL_VALUES: PvPolicyFormModel = {
  name: '',
  mode: 'dryRun',
  iopsEnabled: true,
  storageEnabled: true,
  throughputEnabled: true,
  thresholdPercent: 80,
  thresholdPeriod: { hours: 0, minutes: 5, isCustom: false },
  cooldownPeriod: { hours: 0, minutes: 30, isCustom: false },
  growthPercent: 20,
  minGrowthStepGiB: 5,
  maxSize: null,
  maxIops: null,
  maxThroughputMiBs: null,
  overhead: 20,
  lookbackPeriod: { hours: 6, minutes: 0, isCustom: false },
  minWarmupWindow: { hours: 0, minutes: 30, isCustom: false },
  changeCooldown: { hours: 0, minutes: 15, isCustom: false },
  target: 'max',
  namespaces: [],
  pvcNames: [],
  storageClasses: [],
  pvcLabelMatchExpressions: [],
};
